import { ROLES_SET } from '../constants/action_constants';
import { newAlert } from './alert_actions';
import RequestService from '../services/request_service';
import { sendRequest, completeRequest, errorOnRequest } from './request_state';
import { stringifyQuery } from '../helpers/parseQuerystring';
import { history } from '../helpers/history';

const requestService = new RequestService('node');

//* PURE ACTION FUNCTIONS
function setRoles(items, meta = {}) {
  return {
    type: ROLES_SET,
    data: items,
    meta
  };
}

export const fetchRole = id => async dispatch => {
  dispatch(sendRequest('FetchRoleAdmin'));
  try {
    const payload = await requestService.get(`roles/admin/${id}`);
    return payload.data;
  } catch (errors) {
    dispatch(errorOnRequest(errors));
    return null;
  } finally {
    dispatch(completeRequest('FetchRoleAdmin'));
  }
};

//* VIEW ACTION FUNCTIONS
export const fetchRoles = (params = {}) => async dispatch => {
  dispatch(sendRequest('Roles'));
  try {
    const payload = await requestService.get('roles', params);
    dispatch(setRoles(payload.data));
    dispatch(completeRequest('Roles'));
  } catch (error) {
    error.json().then(e => {
      e.message && dispatch(newAlert('error', 'ERROR:', e.message));
    });
    dispatch(completeRequest('Roles'));
  }
};

export const fetchRolesForAdmin = (params = {}) => async dispatch => {
  history.replace(`/roles?${stringifyQuery(params)}`);

  dispatch(sendRequest('RolesAdmin'));
  try {
    const payload = await requestService.get('roles/admin', params);
    dispatch(setRoles(payload.data, payload.meta));
    dispatch(completeRequest('RolesAdmin'));
  } catch (error) {
    error.json().then(e => {
      e.message && dispatch(newAlert('error', 'ERROR:', e.message));
    });
    dispatch(completeRequest('RolesAdmin'));
  }
};

export const createRole = (params = {}) => async dispatch => {
  dispatch(sendRequest('SaveRole'));
  try {
    const payload = await requestService.post('roles', params);
    dispatch(newAlert('success', 'Success', payload.data.message));
    dispatch(completeRequest('SaveRole'));
    history.replace(`/roles`);
  } catch (error) {
    const e = await error.json();
    const errorMsg =
      e.errors.base || e.message || 'Lo sentimos algo ha salido mal.';
    dispatch(newAlert('error', 'ERROR:', errorMsg));
    dispatch(completeRequest('SaveRole'));
    dispatch(errorOnRequest('SaveRole', e.errors));
  } finally {
    dispatch(completeRequest('SaveRole'));
  }
};

export const editRole = (roleId, params = {}) => async dispatch => {
  dispatch(sendRequest('SaveRole'));
  try {
    const payload = await requestService.put(`roles/${roleId}`, params);
    dispatch(newAlert('success', 'Success', payload.data.message));
    dispatch(completeRequest('SaveRole'));
    history.replace(`/roles`);
  } catch (error) {
    const e = await error.json();
    const errorMsg =
      e.errors.base || e.message || 'Lo sentimos algo ha salido mal.';
    dispatch(newAlert('error', 'ERROR:', errorMsg));
    dispatch(completeRequest('SaveRole'));
    dispatch(errorOnRequest('SaveRole', e.errors));
  } finally {
    dispatch(completeRequest('SaveRole'));
  }
};
